<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="400px">
    <v-card v-if="staff">
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>{{ staff.name }}</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-container>
        <v-row no-gutters>
          <custom-form
            :fields="{ user_id: staff.user.id }"
            :method="method"
            :action="url"
            @submitted="$emit('changed', $event)"
          >
            <v-container>
              <v-row no-gutters>
                <v-col cols="12">
                  <custom-select
                    name="role_id"
                    class="form-group"
                    label="Select role"
                    :items="roles"
                    item_name="name"
                    item_value="id"
                  />
                </v-col>
                <v-col cols="12">
                  <custom-button block color="primary">
                    <v-icon v-if="method === 'post'">mdi-plus</v-icon>
                    <v-icon v-else>mdi-pencil</v-icon>
                    {{ method === "post" ? "Add" : "Edit" }}
                  </custom-button>
                </v-col>
              </v-row>
            </v-container>
          </custom-form>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    staff: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      roles: [],
      key: 1,
    };
  },

  computed: {
    url() {
      return "api/v1/admin/userrole";
    },
  },
  async created() {
    await this.fetchRoles();
  },
  methods: {
    getSelectOptions(data) {
      return data.map(({ id, name }) => ({ value: id, text: name }));
    },
    async fetchRoles() {
      await this.$http
        .get(`api/v1/admin/roles`)
        .then((response) => {
          this.roles = this.getSelectOptions(response.data);
        })
        .catch((error) => {
          Notify.errorFromResponse(error, { close: true });
        });
    },
    checkPermission(permission) {
      const permissions = this.role.permissions.map((permission) => permission.id);
      return permissions.includes(permission.id);
    },
    async togglePermission(permission) {
      const { id } = permission;
      const hasCurrentPermission = this.checkPermission(permission);
      this.isActivating = true;
      if (!hasCurrentPermission) {
        await this.$http
          .post(`api/v1/admin/permissions/${id}`, { role_id: this.role.id })
          .then(() => {
            this.$emit("update:role");
            Notify.success("Operation was success full");
          })
          .catch((error) => {
            Notify.errorFromResponse(error, { close: true });
            this.$emit("update:role");
          })
          .finally(() => (this.isActivating = false));
      } else {
        await this.$http
          .put(`api/v1/admin/permissions/${id}`, { role_id: this.role.id })
          .then(() => {
            this.$emit("update:role");
            Notify.success("Operation was success full");
          })
          .catch((error) => {
            Notify.errorFromResponse(error, { close: true });
            this.$emit("update:role");
          })
          .finally(() => (this.isActivating = false));
      }
    },
  },
};
</script>
